import React, { useCallback } from 'react';
import { Routes, Route, Navigate, useNavigate, useParams } from 'react-router-dom';
import { CircularProgress } from '@ann/web-components';
import {
  PlaygroundContainer,
  HeaderSection,
  ContentArea,
  RoutesContainer,
  LoadingContainer,
} from './PlaygroundPage.styled';
import { AgentProvider, useAgent, DrivesProvider, DocumentsProvider } from './context';
import { Breadcrumb, Header, TabSwitcher, TestChat } from './components';
import { CreatedPage, ConfigPage, KnowledgePage, InstructionsPage, ToolsPage } from './pages';
import { TAB_ROUTES } from './constants/playgroundConstants';

// Placeholder para páginas pendientes
const PlaceholderPage = ({ title }) => (
  <div style={{ padding: '24px' }}>
    <h2>{title}</h2>
    <p>Esta página se implementará próximamente.</p>
  </div>
);

// Componente interno que tiene acceso al contexto
const PlaygroundContent = () => {
  const navigate = useNavigate();
  const { agentId } = useParams();
  const { loading } = useAgent();

  // Handler para cambio de tabs
  const handleTabChange = useCallback((tabId) => {
    const route = TAB_ROUTES[tabId] || 'create';
    navigate(`/v2/playground2/${agentId}/${route}`);
  }, [navigate, agentId]);

  if (loading) {
    return (
      <LoadingContainer>
        <CircularProgress size="xl" />
      </LoadingContainer>
    );
  }

  return (
    <PlaygroundContainer>
      {/* Header Section: Breadcrumb + Header + Tabs */}
      <HeaderSection>
        <Breadcrumb />
        <Header />
        <TabSwitcher onTabChange={handleTabChange} />
      </HeaderSection>

      {/* Content Area: Routes + TestChat */}
      <ContentArea>
        <RoutesContainer >
          <Routes>
            <Route index element={<Navigate to="create" replace />} />
            <Route path="create" element={<CreatedPage />} />
            <Route path="configuration" element={<ConfigPage />} />
            <Route path="knowledge/*" element={<KnowledgePage />} />
            <Route path="instructions" element={<InstructionsPage />} />
            <Route path="tools" element={<ToolsPage />} />
          </Routes>
        </RoutesContainer>

        {/* TestChat siempre visible */}
        <TestChat />
      </ContentArea>
    </PlaygroundContainer>
  );
};

// Componente principal con Providers
const PlaygroundPage = () => {
  return (
    <Routes>
      <Route
        path=":agentId/*"
        element={
          <AgentProvider>
            <DrivesProvider>
              <DocumentsProvider>
                <PlaygroundContent />
              </DocumentsProvider>
            </DrivesProvider>
          </AgentProvider>
        }
      />
    </Routes>
  );
};

export default PlaygroundPage;

